import * as angular from 'angular';
import * as _ from 'underscore';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StoreCampaigns } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import { ICampaignListItem, ICampaignVideoRetailerMessage } from '../../models';
import { CampaignsService } from '../../services/campaigns.service';

interface ICampaignsFilter {
    key: string;
    value: number;
    active: boolean;
    show: boolean;
    isExclusiveOffer?: boolean;
}

export class CampaignsOverviewController {
    static $inject = ['$rootScope', 'campaignsService', 'notificationService', '$translate'];

    isAdvertising = this.$rootScope.$state.current.name === 'app.advertising.overview';
    isRetailing = this.$rootScope.$state.current.name === 'app.marketing-campaigns.overview';
    waiting = true;
    loading = false;
    campaignType = this.$rootScope.enums.CampaignType;
    runningFilters: ICampaignsFilter[] = null;
    archivedFilters: ICampaignsFilter[] = null;

    storeFilter = {
        stores: <StoreCampaigns[]>[],
        store: <StoreCampaigns>null
    };
    campaigns = {
        running: <ICampaignListItem[]>[],
        runningFiltered: <ICampaignListItem[]>[],
        archived: <ICampaignListItem[]>[],
        archivedFiltered: <ICampaignListItem[]>[],
        isShowRunning: true,
        setData: (campaigns: ICampaignListItem[]) => {
            let $self = this.campaigns;
            let filtered = _.where(campaigns, { archived: false });
            $self.running = _.isUndefined(filtered) ? [] : filtered;
            filtered = _.where(campaigns, { archived: true });
            $self.archived = _.isUndefined(filtered) ? [] : filtered;
            $self.runningFiltered = $self.running;
            $self.archivedFiltered = $self.archived;
            _.forEach(this.runningFilters, (filter) => {
                if (filter.value) {
                    filter.show = _.any($self.running, (c) => {
                        return c.Status === filter.value;
                    });
                    return;
                }

                if (filter.isExclusiveOffer) {
                    filter.show = _.any($self.running, (c) => {
                        return c.IsExclusiveOffer;
                    });
                    return;
                }

                filter.show = $self.running.length > 0;
            });

            _.forEach(this.archivedFilters, (filter) => {
                if (filter.value) {
                    filter.show = _.any($self.archived, (campaign) => {
                        return campaign.Status === filter.value;
                    });
                } else {
                    filter.show = $self.archived.length > 0;
                }
            });
        },
        setRunningFiltered: (filter: ICampaignsFilter) => {
            let $self = this.campaigns;
            _.forEach(this.runningFilters, (runningFilter) => {
                runningFilter.active = false;
            });
            filter.active = true;

            let filterObj = this.parseFilter(filter);
            $self.runningFiltered = filterObj ? _.where($self.running, filterObj) : $self.running;
            $self.runningFiltered = this.getFilteredByStore($self.runningFiltered);

        },
        setArchivedFiltered: (filter: ICampaignsFilter) => {
            let $self = this.campaigns;
            if (filter.value) {
                $self.archivedFiltered = _.where($self.archived, { Status: filter.value });
            } else {
                $self.archivedFiltered = $self.archived;
            }
            _.forEach(this.archivedFilters, (runningFilter) => {
                runningFilter.active = false;
            });
            filter.active = true;
            $self.archivedFiltered = this.getFilteredByStore($self.archivedFiltered);
        }
    };

    private campaignStatus = this.$rootScope.enums.CampaignStatus;

    constructor(
        private $rootScope: IRetailerRootScope,
        private campaignsService: CampaignsService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService) {

        this.runningFilters = [
            { key: this.$translate.instant('all'), value: null, active: false, show: false },
            { key: this.$translate.instant('exclusive_offer'), value: null, active: false, show: false, isExclusiveOffer: true },
            { key: this.$translate.instant('scheduled'), value: this.campaignStatus.Scheduled, active: false, show: false },
            { key: this.$translate.instant('active'), value: this.campaignStatus.Running, active: true, show: false },
            { key: this.$translate.instant('draft'), value: this.campaignStatus.Draft, active: false, show: false },
            { key: this.$translate.instant('ad_submission'), value: this.campaignStatus.AdSubmission, active: false, show: false },
            { key: this.$translate.instant('quality_control'), value: this.campaignStatus.QualityControl, active: false, show: false },
            { key: this.$translate.instant('disabled'), value: this.campaignStatus.Disabled, active: false, show: false },
            { key: this.$translate.instant('warning'), value: this.campaignStatus.Warning, active: false, show: false },
            { key: this.$translate.instant('error'), value: this.campaignStatus.Error, active: false, show: false }
        ];

        this.archivedFilters = [
            { key: this.$translate.instant('all'), value: null, active: true, show: false },
            { key: this.$translate.instant('archived'), value: this.campaignStatus.Archived, active: false, show: false },
            { key: this.$translate.instant('completed'), value: this.campaignStatus.Completed, active: false, show: false }
        ];
        this.init();

        $rootScope.$on('CampaignVideoProcessingFinish', (event, data) => this.onUpdateCampaignVideoProcessing(event, data));

        $rootScope.$on('CampaignVideoProcessingError', (event, data) => this.onUpdateCampaignVideoProcessing(event, data));
    }


    gotoView = (campaignID: number, $event: Event) => {
        $event.preventDefault();
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        if (this.isAdvertising) {
            this.$rootScope.$state.go('app.advertising.campaign.view', { id: campaignID });
        } else if (this.isRetailing) {
            this.$rootScope.$state.go('app.marketing-campaigns.view', { id: campaignID });
        }
    }

    toggleShow = (value: boolean) => {
        this.campaigns.isShowRunning = value;
    }

    addCampaign = () => {
        this.waiting = true;
        this.campaignsService.setEditableCampaign(null, false);
        if (this.isAdvertising) {
            this.$rootScope.$state.go('app.advertising.campaign.new');
        } else if (this.isRetailing) {
            this.$rootScope.$state.go('app.marketing-campaigns.new-branded');
        }
    }

    applyRunningFilter = (filter: ICampaignsFilter) => {
        this.campaigns.setRunningFiltered(filter);
    }

    applyArchivedFilter = (filter) => {
        this.campaigns.setArchivedFiltered(filter);
    }

    applyStoreFilter() {

        let runningFilter = _.findWhere(this.runningFilters, { active: true });
        let archivedFilter = _.findWhere(this.archivedFilters, { active: true });
        if (runningFilter) {
            this.campaigns.setRunningFiltered(runningFilter);
        }
        if (archivedFilter) {
            this.campaigns.setArchivedFiltered(archivedFilter);
        }
    }

    private getFilteredByStore(campaigns: ICampaignListItem[]) {
        if (this.storeFilter.store) {
            return _.filter(campaigns, (campaign) => {
                return _.any(this.storeFilter.store.CampaignIDs, (id) => id === campaign.ID);
            });
        }
        return campaigns;
    }

    private parseFilter(filter: ICampaignsFilter): any {
        if (filter.value) {
            return { Status: filter.value };
        }

        if (filter.isExclusiveOffer) {
            return { IsExclusiveOffer: true };
        }

        return null;
    }

    private init = async () => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();
        try {
            let campaigns = <ICampaignListItem[]>await (this.campaignsService.getRetailCampaignsPreview());
            this.storeFilter.stores = await this.campaignsService.getStoresCampaigns();

            this.campaigns.setData(campaigns);
            this.campaigns.isShowRunning = true; // $scope.campaigns.running.length > 0 || $scope.campaigns.archived.length === 0;
            this.campaigns.setRunningFiltered(_.findWhere(this.runningFilters, { active: true }));
            this.loading = true;
            this.notificationService.clearAll();
        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;

    }

    private async onUpdateCampaignVideoProcessing(event: ng.IAngularEvent, data: ICampaignVideoRetailerMessage) {

        if (!data.CampaignID) {
            return;
        }

        var itemRunning = _.find(this.campaigns.running, (element) => {
            return element.ID === data.CampaignID;
        });

        var itemRunningFiltered = _.find(this.campaigns.runningFiltered, (element) => {
            return element.ID === data.CampaignID;
        });

        if (itemRunning || itemRunningFiltered) {

            var newItem: ICampaignListItem = null;
            try {
                newItem = <ICampaignListItem>await this.campaignsService.getRetailCampaign(data.CampaignID);
            } catch (error) {
                this.notificationService.showErrorMessage(error);
            }

            if (newItem) {
                var indexRunning = this.campaigns.running.indexOf(itemRunning);
                if (indexRunning > 0) {
                    this.campaigns.running.splice(indexRunning, 1, newItem);
                }

                var indexRunningFiltered = this.campaigns.runningFiltered.indexOf(itemRunningFiltered);
                if (indexRunningFiltered > 0) {
                    this.campaigns.runningFiltered.splice(indexRunningFiltered, 1, newItem);
                }
            }
        }
    }
}

angular
    .module('naut').component('campaignsOverview', {
        template: require('./campaignsOverview.html'),
        controller: CampaignsOverviewController,
        controllerAs: 'vm'
    });





// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/campaigns/components/campaignsOverview/campaignsOverview.component.ts